<template>
  <div class="page">
    <commonHeader heading="数字化教学评估">
      <template v-slot:add>
        <div style="cursor: pointer;color: #fff;" @click="toDigitalAllData()">
          <span>全部数据</span>
          <span class="mdi mdi-chevron-right"></span>
        </div>
      </template>
    </commonHeader>
    <!-- 陈述性知识不同教学策略效果评估表 -->
    <div class="big-title">
      <div class="left-title">陈述性知识不同教学策略效果评估表</div>
      <div class="right-detail">
        <!-- <div class="title">刷新图谱</div> -->
        <span class="title-icon mdi mdi-refresh"></span>
        <span class="title-icon mdi mdi-fullscreen icon-mrl" @click="fullScreenDisplay('digitalOne')"></span>
      </div>
    </div>
    <div class="course-data">
      <div class="course-row">
        <v-card>
          <div class="course-echart">
            <div id="digitalOne"></div>
          </div>
        </v-card>
      </div>
    </div>

    <!-- 概念性知识不同教学策略效果评估表 -->
    <div class="big-title">
      <div class="left-title">概念性知识不同教学策略效果评估表</div>
      <div class="right-detail">
        <!-- <div class="title">刷新图谱</div> -->
        <span class="title-icon mdi mdi-refresh"></span>
        <span class="title-icon mdi mdi-fullscreen icon-mrl" @click="fullScreenDisplay('digitalTwo')"></span>
      </div>
    </div>
    <div class="course-data">
      <div class="course-row">
        <v-card>
          <div class="course-echart" style="background-color: #3f4d69;">
            <div id="digitalTwo"></div>
          </div>
        </v-card>
      </div>
    </div>

    <!-- 程序性知识不同教学策略效果评估表 -->
    <div class="big-title">
      <div class="left-title">程序性知识不同教学策略效果评估表</div>
      <div class="right-detail">
        <!-- <div class="title">刷新图谱</div> -->
        <span class="title-icon mdi mdi-refresh"></span>
        <span class="title-icon mdi mdi-fullscreen icon-mrl" @click="fullScreenDisplay('digitalThree')"></span>
      </div>
    </div>
    <div class="course-data">
      <div class="course-row">
        <v-card>
          <div class="course-echart">
            <div id="digitalThree"></div>
          </div>
        </v-card>
      </div>
    </div>

    <!-- 原则性知识不同教学策略效果评估表 -->
    <div class="big-title">
      <div class="left-title">原则性知识不同教学策略效果评估表</div>
      <div class="right-detail">
        <!-- <div class="title">刷新图谱</div> -->
        <span class="title-icon mdi mdi-refresh"></span>
        <span class="title-icon mdi mdi-fullscreen icon-mrl" @click="fullScreenDisplay('digitalFourth')"></span>
      </div>
    </div>
    <div class="course-data">
      <div class="course-row">
        <v-card>
          <div class="course-echart" style="background-color: #262623;">
            <div id="digitalFourth"></div>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import CommonHeader from '@/components/DataService/CommonHeader.vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    CommonHeader
  },
  data() {
    return {
      digitalOne: false,
      digitalTwo: false,
      digitalThree: false,
      digitalFourth: false,

    };
  },
  computed: {
    ...mapGetters(['isMobile']),
  },
  watch: {
    'isMobile.isMobile'(news) {
      if (!news) {
        setTimeout(() => {
          this.digitalOne.dispose();
          this.digitalTwo.dispose();
          this.digitalThree.dispose();
          this.digitalFourth.dispose();
          this.getChartDataOne();
          this.getChartDataTwo();
          this.getChartDataThree();
          this.getChartDataFourth();
        }, 500);
      }
    },
  },
  created() {

  },

  mounted() {
    this.getChartDataOne()
    this.getChartDataTwo()
    this.getChartDataThree()
    this.getChartDataFourth()
  },

  methods: {
    getChartDataOne() {
      this.digitalOne = echarts.init(document.getElementById('digitalOne'));
      var option;

      option = {
        title: {
          // text: 'Stacked Line'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['五星教学法_程序性知识模板', '工学一体标准教学策略','主题式教学-程序性知识模板','A老师设计的教学策略','B老师设计的教学策略']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['引用的任务数', '累计学习人次', '任务考核平均得分', '关联知识点测试得分率', '任务累计话题互动人数', '课程完学率']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '五星教学法_程序性知识模板',
            type: 'line',
            stack: 'Total',
            data: [120, 132, 101, 134, 90, 230]
          },
          {
            name: '工学一体标准教学策略',
            type: 'line',
            stack: 'Total',
            data: [35, 182, 191, 234, 290, 500]
          },
          {
            name: '主题式教学-程序性知识模板',
            type: 'line',
            stack: 'Total',
            data: [85, 192, 111, 24, 200, 260]
          },
          {
            name: 'A老师设计的教学策略',
            type: 'line',
            stack: 'Total',
            data: [85, 192, 111, 24, 200, 190]
          },
          {
            name: 'B老师设计的教学策略',
            type: 'line',
            stack: 'Total',
            data: [15, 172, 191, 240, 100, 150]
          },
        ]
      };

      this.digitalOne.setOption(option);

      // 根据页面大小自动响应图表大小
      let _this = this;
      window.addEventListener('resize', function () {
        _this.digitalOne.resize();
      });
    },
    getChartDataTwo() {
      this.digitalTwo = echarts.init(document.getElementById('digitalTwo'));
      var option;

      option = {
        // backgroundColor: '#3f4d69', // 设置整个图表背景颜色
        title: {
          // text: 'Stacked Line'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          textStyle: {
            color: '#fff' // 这里设置图例文字的颜色为白色
          },
          data: ['五星教学法_程序性知识模板', '工学一体标准教学策略','主题式教学-程序性知识模板','A老师设计的教学策略','B老师设计的教学策略']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            color: '#fff' // 改变X轴标注颜色为白色
          },
          data: ['引用的任务数', '累计学习人次', '任务考核平均得分', '关联知识点测试得分率', '任务累计话题互动人数', '课程完学率']
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#fff' // 改变y轴标注颜色为白色
          },
        },
        series: [
          {
            name: '五星教学法_程序性知识模板',
            type: 'line',
            stack: 'Total',
            data: [120, 132, 101, 134, 90, 230]
          },
          {
            name: '工学一体标准教学策略',
            type: 'line',
            stack: 'Total',
            data: [35, 182, 191, 234, 290, 500]
          },
          {
            name: '主题式教学-程序性知识模板',
            type: 'line',
            stack: 'Total',
            data: [85, 192, 111, 24, 200, 260]
          },
          {
            name: 'A老师设计的教学策略',
            type: 'line',
            stack: 'Total',
            data: [85, 192, 111, 24, 200, 190]
          },
          {
            name: 'B老师设计的教学策略',
            type: 'line',
            stack: 'Total',
            data: [15, 172, 191, 240, 100, 150]
          },
        ]
      };

      this.digitalTwo.setOption(option);

      // 根据页面大小自动响应图表大小
      let _this = this;
      window.addEventListener('resize', function () {
        _this.digitalTwo.resize();
      });
    },
    getChartDataThree() {
      this.digitalThree = echarts.init(document.getElementById('digitalThree'));
      var option;

      option = {
        // backgroundColor: '#3f4d69', // 设置背景颜色为浅灰色
        title: {
          // text: 'Stacked Line'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['五星教学法_程序性知识模板', '工学一体标准教学策略','主题式教学-程序性知识模板','A老师设计的教学策略','B老师设计的教学策略']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['引用的任务数', '累计学习人次', '任务考核平均得分', '关联知识点测试得分率', '任务累计话题互动人数', '课程完学率']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '五星教学法_程序性知识模板',
            type: 'line',
            stack: 'Total',
            data: [120, 132, 101, 134, 90, 230]
          },
          {
            name: '工学一体标准教学策略',
            type: 'line',
            stack: 'Total',
            data: [35, 182, 191, 234, 290, 500]
          },
          {
            name: '主题式教学-程序性知识模板',
            type: 'line',
            stack: 'Total',
            data: [85, 192, 111, 24, 200, 260]
          },
          {
            name: 'A老师设计的教学策略',
            type: 'line',
            stack: 'Total',
            data: [85, 192, 111, 24, 200, 190]
          },
          {
            name: 'B老师设计的教学策略',
            type: 'line',
            stack: 'Total',
            data: [15, 172, 191, 240, 100, 150]
          },
        ]
      };

      this.digitalThree.setOption(option);

      // 根据页面大小自动响应图表大小
      let _this = this;
      window.addEventListener('resize', function () {
        _this.digitalThree.resize();
      });
    },
    getChartDataFourth() {
      this.digitalFourth = echarts.init(document.getElementById('digitalFourth'));
      var option;

      option = {
        // backgroundColor: '#3f4d69', // 设置背景颜色为浅灰色
        title: {
          // text: 'Stacked Line'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          textStyle: {
            color: '#fff' // 这里设置图例文字的颜色为白色
          },
          data: ['五星教学法_程序性知识模板', '工学一体标准教学策略','主题式教学-程序性知识模板','A老师设计的教学策略','B老师设计的教学策略']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            color: '#fff' // 改变X轴标注颜色为白色
          },
          data: ['引用的任务数', '累计学习人次', '任务考核平均得分', '关联知识点测试得分率', '任务累计话题互动人数', '课程完学率']
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#fff' // 改变y轴标注颜色为白色
          },
        },
        series: [
          {
            name: '五星教学法_程序性知识模板',
            type: 'line',
            stack: 'Total',
            data: [120, 132, 101, 134, 90, 230]
          },
          {
            name: '工学一体标准教学策略',
            type: 'line',
            stack: 'Total',
            data: [35, 182, 191, 234, 290, 500]
          },
          {
            name: '主题式教学-程序性知识模板',
            type: 'line',
            stack: 'Total',
            data: [85, 192, 111, 24, 200, 260]
          },
          {
            name: 'A老师设计的教学策略',
            type: 'line',
            stack: 'Total',
            data: [85, 192, 111, 24, 200, 190]
          },
          {
            name: 'B老师设计的教学策略',
            type: 'line',
            stack: 'Total',
            data: [15, 172, 191, 240, 100, 150]
          },
        ]
      };

      this.digitalFourth.setOption(option);

      // 根据页面大小自动响应图表大小
      let _this = this;
      window.addEventListener('resize', function () {
        _this.digitalFourth.resize();
      });
    },
    fullScreenDisplay(id) {
      var element = document.getElementById(id);
      var requestFullScreen = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullscreen;
      if (requestFullScreen) {
          // 进入全屏
          requestFullScreen.call(element);
      }
    },
    toDigitalAllData() {
      this.$router.push({
        name: 'DigitalAllData',
        query: {
          detailId: 1,
        },
      });
    },
  }
}
</script>

<style scoped>
.page {
  padding: 10px 15px;

  .big-title {
    display: flex;
    padding: 20px 1px 5px 1px;
    .left-title {
      font-size: 18px;
      flex: 1;
      text-align: left;
    }

    .right-detail {
      cursor: pointer;
      text-align: right;
      display: flex;
      .title {
        font-size: 16px !important;
        flex: 1;
        height: 25px;
        line-height: 25px;
      }
      .title-icon {
        font-size: 20px !important;
      }
      .icon-mrl {
        margin-left: 5px;
      }
    }
  }

  .course-data {
    .course-row {
      .v-card {
        height: 100%;
      }

      flex: 1;

      .course-header {
        font-size: 20px;
        padding: 10px 5px;
      }

      .course-echart {
        padding: 10px 0;
        text-align: center;
        #digitalOne,
        #digitalTwo,
        #digitalThree,
        #digitalFourth {
          display: inline-block;
          width: 100%;
          height: 450px;
        }
      }
    }
  }
}
</style>